<script lang="tsx" setup>
import useVulnerabilityColumns from './vulnerabilityColumns'
import FilterContainer from '@/components/filter/FilterContainer.vue'
import TextFilter from '@/components/filter/TextFilter.vue'
import InstanceFilter from '@/components/filter/InstanceFilter.vue'
import RiskCatalogFilter from '@/components/filter/RiskCatalogFilter.vue'
import RiskCategoryFilter from '@/components/filter/RiskCategoryFilter.vue'

const props = defineProps<{
	component: string
}>()

const { columns, custom, all } = useVulnerabilityColumns(props.component)
</script>

<template>
	<FilterContainer :columns="all" :custom="custom" bookmark="vulnerabilities-bookmark">
		<div class="p-2 filter-col" v-if="columns.name.value.isVisible">
			<TextFilter id="name-filter-vulnerability" v-model="columns.name.value"></TextFilter>
		</div>

		<div class="p-2 filter-col" v-if="columns.comment.value.isVisible">
			<TextFilter id="comment-filter-vulnerability" v-model="columns.comment.value"></TextFilter>
		</div>

		<div class="p-2 filter-col" v-if="columns.code.value.isVisible">
			<TextFilter id="code-filter-vulnerability" v-model="columns.code.value"></TextFilter>
		</div>

		<div class="p-2 filter-col" v-if="columns.catalog.value.isVisible">
			<RiskCatalogFilter id="catalog-filter-vulnerability" v-model="columns.catalog.value"></RiskCatalogFilter>
		</div>

		<div class="p-2 filter-col" v-if="columns.category.value.isVisible">
			<RiskCategoryFilter id="category-filter-vulnerability" v-model="columns.category.value"></RiskCategoryFilter>
		</div>

		<div class="p-2 filter-col" v-show="columns.instance.value.isVisible">
			<InstanceFilter id="instance-filter-vulnerability" v-model="columns.instance.value"></InstanceFilter>
		</div>
		<div class="p-2 filter-col" v-if="columns.description.value.isVisible">
			<TextFilter id="description-filter-vulnerability" v-model="columns.description.value"></TextFilter>
		</div>

		<!-- to-do: add score filter  -->
	</FilterContainer>
</template>
